/**
 * 埋点活动商品来源标识（折扣档 / 弹窗直拉）。
 *
 * BI 上报字段名当前为 order_from（ORDER_CREATE / GATEWAY_SHOW / RESULT / CLICK 透传）。
 * 若 BI 正式字段名变更：全局搜「BI_TRACK_ORDER_FROM_FIELD」一并替换 payload key 与注释。
 * 与创单 API body 的 order_from（paywall / profile）语义不同，勿混用。
 */
export const TRACK_ORDER_FROM = {
    /** 首章解锁价格折扣（章节原价高于现价，且非活动商品）。 */
    FIRST_CHAPTER_DISCOUNT: 'fch_discount',
    /** 付费墙折扣活动商品（OfferGoods）/ 充值挽留弹窗直拉商品 */
    LOW_PRICE_COINS: 'low_price_coins',
    /** 会员取消挽留弹窗直拉订阅商品（对齐 EActivityNoType.CancelRecallPopup） */
    CANCEL_RECALL: 'sub_benefit_retain',
} as const;

/**
 * BI 活动商品来源埋点字段名（payload key）。
 * @see TRACK_ORDER_FROM 文件头「BI_TRACK_ORDER_FROM_FIELD」替换说明
 */
export const BI_TRACK_ORDER_FROM_FIELD = 'order_from' as const;

export type TTrackOrderFrom = (typeof TRACK_ORDER_FROM)[keyof typeof TRACK_ORDER_FROM];

/** 支付结果等埋点的 trigger_scene 约定值 */
export const TRACK_TRIGGER_SCENE = {
    /** 充值挽留弹窗直接拉起支付 */
    RECHARGE_POP_UP: 'recharge_pop_up',
    /** 会员取消挽留弹窗直接拉起订阅支付 */
    SUBSCRIBE_POP_UP: 'subscribe_pop_up',
} as const;
